import React from 'react'
import "./header.css"
import header from "../../img/logo.png"
const Header = () => {
    return (
        <div className="h">
            <img src={header} alt="" />
            
        </div>
    )
}

export default Header
